
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/company/terms",
      function () {
        return require("private-next-pages/phone/company/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/company/terms"])
      });
    }
  